import {
	ifAuthenticated,
	ifAuthenticatedOnline,
	canAccess,
	AppTabs,
	Edit,
	Create,
	Crud
} from '@/router/index'

import ComplianceDocument from '@/components/modules/compliance/ComplianceDocument'
import ComplianceNonconformity from '@/components/modules/compliance/ComplianceNonconformity'
import ComplianceAudit from '@/components/modules/compliance/ComplianceAudit'
import ComplianceRisk from '@/components/modules/compliance/ComplianceRisk'
import ComplianceAsset from '@/components/modules/compliance/ComplianceAsset'
import ComplianceSoaMatrix from '@/components/modules/compliance/ComplianceSoaMatrix'
import ComplianceDashboard from '@/components/modules/compliance/ComplianceDashboard'
import ComplianceManagementReview from '@/components/modules/compliance/ComplianceManagementReview'
import ComplianceObjective from '@/components/modules/compliance/ComplianceObjective'
import ComplianceContextIssue from '@/components/modules/compliance/ComplianceContextIssue'
import ComplianceStakeholder from '@/components/modules/compliance/ComplianceStakeholder'
import ComplianceIncident from '@/components/modules/compliance/ComplianceIncident'
import ComplianceSupplierEvaluation from '@/components/modules/compliance/ComplianceSupplierEvaluation'
import ComplianceCompetence from '@/components/modules/compliance/ComplianceCompetence'
import ComplianceAuditProgram from '@/components/modules/compliance/ComplianceAuditProgram'

// Factory per le risorse standard del modulo (lista/create/edit/show)
const complianceResource = (slug, label, showComponent, icon) => ([
	{
		path: '/' + slug,
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/' + slug + '/', text: label, module: 'compliance' }] },
		children: [
			{
				path: '/' + slug + '/',
				name: slug + '-index',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'compliance', next) },
				component: Crud,
				meta: { title: label },
				props: { modelDef: slug, title: label, actionIcon: icon, styleClass: 'mb-offset' }
			}
		]
	},
	{
		path: '/' + slug + '/create',
		name: slug + '-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: { title: label },
		props: (route) => ({ modelDef: slug, defaultInput: route.params.defaultInput || null, redirect: route.params.redirect })
	},
	{
		path: '/' + slug + '/:id/edit',
		name: slug + '-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: { title: label },
		props: (route) => ({ modelDef: slug, id: parseInt(route.params.id) })
	},
	{
		path: '/' + slug + '/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({ tabs: [{ to: '/' + slug + '/' + parseInt(route.params.id) + '/', text: label }] }),
		children: [
			{
				path: '',
				name: slug + '-show',
				beforeEnter: ifAuthenticatedOnline,
				component: showComponent,
				meta: { title: label },
				props: (route) => ({ id: parseInt(route.params.id) })
			}
		]
	}
])

export const compliance = [
	// Dashboard SGI (route flat)
	{
		path: '/compliancedashboard',
		name: 'compliancedashboard-index',
		beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'compliance', next) },
		component: ComplianceDashboard,
		meta: { title: 'Dashboard SGI' }
	},
	...complianceResource('compliancedocuments', 'Documenti SGI', ComplianceDocument, 'mdi-file-document-multiple-outline'),
	...complianceResource('compliancenonconformities', 'Non Conformità', ComplianceNonconformity, 'mdi-alert-octagon-outline'),
	...complianceResource('complianceaudits', 'Audit', ComplianceAudit, 'mdi-clipboard-check-outline'),
	// Programma Audit (vista calendario, route flat)
	{
		path: '/complianceauditprogram',
		name: 'complianceauditprogram-index',
		beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'compliance', next) },
		component: ComplianceAuditProgram,
		meta: { title: 'Programma Audit' }
	},
	...complianceResource('compliancereviews', 'Riesame della Direzione', ComplianceManagementReview, 'mdi-clipboard-text-clock-outline'),
	...complianceResource('complianceobjectives', 'Obiettivi e Indicatori', ComplianceObjective, 'mdi-target-variant'),
	...complianceResource('compliancecontextissues', 'Contesto (SWOT)', ComplianceContextIssue, 'mdi-chart-box-outline'),
	...complianceResource('compliancestakeholders', 'Parti Interessate', ComplianceStakeholder, 'mdi-account-multiple-outline'),
	...complianceResource('complianceincidents', 'Incidenti di Sicurezza', ComplianceIncident, 'mdi-flash-alert-outline'),
	...complianceResource('compliancesupplierevaluations', 'Valutazione Fornitori', ComplianceSupplierEvaluation, 'mdi-truck-check-outline'),
	...complianceResource('compliancecompetences', 'Competenze e Formazione', ComplianceCompetence, 'mdi-school-outline'),
	...complianceResource('compliancerisks', 'Rischi', ComplianceRisk, 'mdi-shield-alert-outline'),
	...complianceResource('complianceassets', 'Asset', ComplianceAsset, 'mdi-database-outline'),
	// SoA: vista matrice dedicata (route flat, senza AppTabs)
	{
		path: '/compliancesoa',
		name: 'compliancesoa-index',
		beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'compliance', next) },
		component: ComplianceSoaMatrix,
		meta: { title: 'Dichiarazione di Applicabilità (SoA)' }
	},
]
